/**
 *  @class
 *  @function FacetsToggle
 */
// function debounce(func, wait, immediate) {
//   let timeout;
//   return function(...args) {
//     const context = this;
//     const later = function() {
//       timeout = null;
//       if (!immediate) func.apply(context, args);
//     };
//     const callNow = immediate && !timeout;
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//     if (callNow) func.apply(context, args);
//   };
// }

// for desktop sort and filter
function stickyFilter() {
  // Cache DOM elements
  const filterBar = document.querySelectorAll('#FacetFiltersForm-bar');
  const excludedSections = [
    'section-rich-text',
    'section-logo-list',
    'section-footer',
    'section-custom-liquid',
  ];
  
  // Cache for section positions to avoid recalculating on every scroll
  let sectionBreakpoints = [];
  let filterBarTop = 0;
  let isSticky = false;
  let resizeTimeout;
  
  // Function to calculate and cache all the important positions
  function calculateBreakpoints() {
    sectionBreakpoints = [];
    
    // Get filter bar position
    if (filterBar.length > 0) {
      const filterElement = filterBar[0];
      // Get the original position relative to the document
      const filterRect = filterElement.getBoundingClientRect();
      filterBarTop = filterRect.top + window.scrollY;
    }
    
    // Find all excluded sections and their positions
    excludedSections.forEach(sectionClass => {
      const section = document.querySelector(`.${sectionClass}`);
      if (section) {
        const rect = section.getBoundingClientRect();
        const sectionTop = rect.top + window.scrollY - window.innerHeight + 100; // When section enters viewport
        const sectionBottom = rect.bottom + window.scrollY - 100; // When section exits viewport
        
        sectionBreakpoints.push({
          top: sectionTop,
          bottom: sectionBottom,
          name: sectionClass
        });
      }
    });
  }
  
  // Function to determine if we should be sticky based on breakpoints
  function shouldBeSticky(scrollY) {
    // First check if we've scrolled past the filter bar
    if (scrollY + 120 <= filterBarTop) {
      return false;
    }
    
    // Then check if we're in range of any excluded section
    for (const section of sectionBreakpoints) {
      if (scrollY >= section.top && scrollY <= section.bottom) {
        return false;
      }
    }
    
    return true;
  }
  
  // Main scroll handler with debouncing
  let lastScrollPosition = 0;
  let lastScrollTime = 0;
  
  function handleScroll() {
    const now = Date.now();
    const scrollY = window.scrollY;
    
    // Skip processing if scrolling too rapidly (except on direction change)
    if (now - lastScrollTime < 16 && // ~60fps
        ((scrollY > lastScrollPosition && lastScrollPosition > 0) || 
         (scrollY < lastScrollPosition && lastScrollPosition > 0))) {
      return;
    }
    
    // Determine sticky state based on pre-calculated breakpoints
    const newStickyState = shouldBeSticky(scrollY);
    
    // Only update DOM if state has changed
    if (newStickyState !== isSticky) {
      isSticky = newStickyState;
      
      filterBar.forEach(filter => {
        if (newStickyState) {
          if (!filter.classList.contains('sticky')) {
            filter.classList.add('sticky');
          }
        } else {
          if (filter.classList.contains('sticky')) {
            filter.classList.remove('sticky');
          }
        }
      });
    }
    
    lastScrollPosition = scrollY;
    lastScrollTime = now;
  }

  // Function for handling window resize
  function handleResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      calculateBreakpoints();
      handleScroll(); // Check state immediately after resize
    }, 200);
  }
  
  // Initialize
  function init() {
    calculateBreakpoints();
    
    // Use passive event listeners for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });
    
    // Initial state check
    handleScroll();
  }
  
  // Set up MutationObserver for dynamic DOM changes
  const observer = new MutationObserver(function() {
    // Recalculate breakpoints when DOM changes
    calculateBreakpoints();
    handleScroll();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false, // We only care about structure changes
  });
  
  // Initialize once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}

// Initialize the sticky filter functionality when the DOM is ready
window.addEventListener("DOMContentLoaded", stickyFilter);

// for mobile sort and filter
function initMobileFiltersHandler() {
  // DOM elements
  const facetsToggle = document.querySelectorAll('.mobile-filters');
  const richTextSection = document.querySelector('.section-rich-text');
  const footer = document.querySelector('.footer');

  // Guard clause for missing elements
  if (!facetsToggle.length || !richTextSection || !footer) {
    return;
  }

  // State
  let lastScrollTop = 0;
  let scrollTimeout;

  function checkVisibility(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom >= 0;
  }

  function handleScroll() {
    // Debounce scroll handler
    if (scrollTimeout) {
      cancelAnimationFrame(scrollTimeout);
    }

    scrollTimeout = requestAnimationFrame(() => {
      const isMobile = window.innerWidth <= 768;
    
      if (!isMobile) {
        facetsToggle.forEach(toggle => toggle.style.display = '');
        return;
      }

      const currentScrollTop = window.scrollY;

      // Check for rich text section or footer visibility
      if (checkVisibility(richTextSection) || checkVisibility(footer)) {
        facetsToggle.forEach(toggle => toggle.style.display = 'none');
        return;
      }

      // Handle scroll direction
      if (currentScrollTop > lastScrollTop) {
        facetsToggle.forEach(toggle => toggle.style.display = 'none');  // Scrolling down
      } else {
        facetsToggle.forEach(toggle => toggle.style.display = '');      // Scrolling up
      }

      // Update last scroll position, preventing negative values
      lastScrollTop = Math.max(0, currentScrollTop);
    });
  }

  // Attach event listeners
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);

  // Return cleanup function
  return function cleanup() {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', handleScroll);
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const cleanup = initMobileFiltersHandler();
  
  // Optional: Store cleanup function for later use
  window.mobileFiltersCleanup = cleanup;
});

class FacetsToggle {

  constructor() {
    this.container = document.getElementById('Facet-Drawer');
    let button = document.getElementById('Facets-Toggle');

    // Add functionality to buttons
    if (button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementsByTagName('body')[0].classList.toggle('open-cc');
        this.container.classList.toggle('active');
      });
    }
    setTimeout(function () {
      window.dispatchEvent(new Event('resize.resize-select'));
    }, 10);
  }
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }
    stickyFilter()
    initMobileFiltersHandler()

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);

        new FacetsToggle();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);

    new FacetsToggle();
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }
    stickyFilter()
    initMobileFiltersHandler()
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm collapsible-row, #FacetFiltersFormMobile collapsible-row');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('collapsible-row') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`collapsible-row[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    new FacetsToggle();

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('collapsible-row'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

window.addEventListener('load', () => {
  new FacetsToggle();
});